@if (label) {
  <label class="form-label">
    {{ label }}
  </label>
}
<div class="position-relative">
  @if (maxlength > 0) {
    <span class="character-count">
      {{ remainingCharacters }}
    </span>
  }
  <textarea
    class="form-control {{ class }}"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [ngModel]="value"
    [rows]="rows"
    (ngModelChange)="valueChanged($event)"
    [maxlength]="maxlength"></textarea>
</div>
